import { createFileRoute } from "@tanstack/react-router";
import { MarketingLayout } from "@/content-site/components/marketing-layout";
export const Route = createFileRoute("/_content/pricing")({ component: MarketingLayout });
